import { createDraftSafeSelector } from '@reduxjs/toolkit'
import type { RootState } from '../store'

type ParamSelector<S> = (state: RootState) => S

/**
 * Memoize a parameterized Reselect selector by cache key so `useSelector(fn(param))`
 * does not create a new selector instance every render (which re-subscribes on every store tick).
 */
export function getCachedParamSelector<S>(
    cache: Map<string, ParamSelector<S>>,
    cacheKey: string,
    inputSelector: (state: RootState) => S
): ParamSelector<S> {
    let selector = cache.get(cacheKey)
    if (!selector) {
        selector = createDraftSafeSelector(inputSelector, (value) => value)
        cache.set(cacheKey, selector)
    }
    return selector
}
